import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import ResidentGeneralMeetingRepo from './ResidentGeneralMeetingRepo'
import {PrimaryStyledButton, SecondaryButton} from '../../styledComponents/Button'
import {getQueryParameter, NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import {Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
}

interface State {
    unitOwnerConfirmationKey: string
    isOpenUnitOwnerConfirmationDialog: boolean
}

class ResidentUnitOwnerConfirmationRedirectPage extends Component<Props & ResidentPagePropsSet, State> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        const unitOwnerConfirmationKey = getQueryParameter('unitOwnerConfirmationKey', this.props.location.search)
        if (!unitOwnerConfirmationKey) {
            throw new Error('区分所有者の確認用キーがありません。画面遷移が不正です。')
        }
        this.state = {
            unitOwnerConfirmationKey: unitOwnerConfirmationKey,
            isOpenUnitOwnerConfirmationDialog: false,
        }
        this.handleHomeButtonClick = this.handleHomeButtonClick.bind(this)
        this.handlePersonalSettingButtonClick = this.handlePersonalSettingButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const unitOwnerResponse = await NatAsyncCallFunction(
                this.props.residentGeneralMeetingRepo.getUnitOwnerByLoginUserRoom.bind(
                    this.props.residentGeneralMeetingRepo,
                ),
                this.props.navigate,
            )

            if (!unitOwnerResponse) {
                return
            }

            const unitOwner = unitOwnerResponse.details
            const loginUserId = SessionStorageHelper.getStringItemOrNull('userId')
            if (!loginUserId) {
                throw new Error('ユーザIDの取得に失敗しました。')
            }

            if (unitOwner !== null) {
                this.setState({
                    isOpenUnitOwnerConfirmationDialog: true,
                })
                return
            }

            try {
                const result = await NatAsyncCallFunction(
                    this.props.residentGeneralMeetingRepo.checkUnitOwnerConfirmationKey.bind(
                        this.props.residentGeneralMeetingRepo,
                        this.state.unitOwnerConfirmationKey,
                    ),
                    this.props.navigate,
                )

                if (!result) {
                    return
                }
            } catch (e) {
                this.props.navigate(
                    '/resident/general-meeting/error',
                )
                return
            }

            this.props.navigate(
                '/resident/general-meeting/unit-owner-confirmation',
                {
                    state: {
                        unitOwnerConfirmationKey: this.state.unitOwnerConfirmationKey,
                    },
                },
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleHomeButtonClick(): void {
        this.props.navigate('/resident/mypage',)
    }

    handlePersonalSettingButtonClick(): void {
        this.props.navigate('/resident/personalSetting')
    }

    render(): ReactNode {
        return <>
            <Dialog
                id={'pp-dialog'}
                open={this.state.isOpenUnitOwnerConfirmationDialog}
                aria-labelledby={'alert-dialog-title'}
                aria-describedby={'alert-dialog-description'}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
            >
                <StyledDialogTitle id={'alert-dialog-title'}>
                    区分所有者の確認状況
                </StyledDialogTitle>
                <DialogContent>
                    <StyledDialogContentText>
                        <div>区分所有者は既に確認されています。</div>
                        <Box height={'24px'}/>
                        <div>区分所有者の確認を変更したい場合には、個人設定ページから変更いただけます。</div>
                    </StyledDialogContentText>
                </DialogContent>
                <StyledDialogActions disableSpacing>
                    <PrimaryStyledButton onClick={this.handleHomeButtonClick}>
                        ホームへ
                    </PrimaryStyledButton>
                    <SecondaryButton onClick={this.handlePersonalSettingButtonClick}>
                        個人設定へ
                    </SecondaryButton>
                </StyledDialogActions>
            </Dialog>
        </>
    }
}

export default createResidentPage(ResidentUnitOwnerConfirmationRedirectPage)

const StyledDialogTitle = styled(DialogTitle)`
  &.MuiTypography-h6 {
    font-size: ${FontSize.Accent};
    font-weight: ${FontWeights.Bold};
    color: ${Colors.Body};
    line-height: 36px;
  }
`

const StyledDialogContentText = styled(DialogContentText)`
  &.MuiDialogContentText-root {
    font-size: ${FontSize.Body};
    color: ${Colors.Body};
  }
`

const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: 8px 24px 50px;
  }

  gap: 30px;
  flex-direction: column;
`
